<template>
    <div>
        <h2>Add new incident</h2>
        <hr />
        <div class="bootstrap-iso">
            <div class="container-fluid" v-if="incident">
                <div class="row">
                    <div class="col-md-12 col-md-12 col-sm-12 col-xs-12">
                        <h3>
                            <small>Incident details</small>
                        </h3>
                        <form>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label
                                            class="control-label"
                                            for="componentType"
                                        >Affected Component</label>
                                        <br />
                                        <b-form-select
                                            v-model="selectedComponent"
                                            :options="availableComponents"
                                        ></b-form-select>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="control-label" for="type">Incident Type</label>
                                        <br />
                                        <b-form-select
                                            v-model="selectedIncidentType"
                                            :options="availableIncidentTypes"
                                        ></b-form-select>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <label class="control-label" for="status">Component Status</label>
                                        <br />
                                        <b-form-select
                                            v-model="selectedStatus"
                                            :options="availableStatuses"
                                        ></b-form-select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                        <label class="control-label" for="startDate">
                                            Start date (UTC)
                                            <span class="asteriskField">*</span>
                                        </label>
                                        <div class="input-group date">
                                            <datetime
                                                v-model="incident.startDate"
                                                placeholder="Select start date in UTC"
                                                type="datetime"
                                                :format="dateTimeFormat"
                                                zone="UTC"
                                                input-class="form-control"
                                            ></datetime>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                                        <label class="control-label" for="endDate">End date (UTC)</label>
                                        <div class="input-group date">
                                            <datetime
                                                v-model="incident.endDate"
                                                placeholder="Select end date in UTC"
                                                type="datetime"
                                                :format="dateTimeFormat"
                                                zone="UTC"
                                                input-class="form-control"
                                            ></datetime>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="pull-right">
                            <button
                                class="btn btn-outline btn-success"
                                v-on:click.prevent="update"
                            >Update</button>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h3>
                            <small>Messages</small>
                        </h3>
                        <button
                            class="btn btn-small btn-primary btn--message"
                            @click.prevent="newIncidentMessage()"
                        >
                            <icon name="plus" class="icon" title="Add"></icon>Add message
                        </button>
                        <div class="row list-incident-messages">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <blockquote
                                    class="blockquote"
                                    v-for="message in incident.messages"
                                    v-bind:key="message.id"
                                >
                                    <p
                                        class="mb-0"
                                        v-for="line in message.body.split(/\r?\n/)"
                                        v-bind:key="line"
                                    >
                                        {{ line }}<br/>
                                    </p>
                                    <footer class="blockquote-footer">
                                        <span>
                                            Posted on {{ message.postedAt | date }} at {{ message.postedAt | time }} UTC
                                            &nbsp; &mdash;
                                            <i
                                                class="message-action"
                                                @click.prevent="editIncidentMessage(message)"
                                            >
                                                <icon name="edit" class="icon" title="Edit"></icon>
                                                <i class="icon-label">Edit</i>
                                            </i>
                                            &nbsp;
                                            <i
                                                class="message-action"
                                                @click.prevent="confirmDeleteMessage(message.id)"
                                                v-if="incident.messages.length !== 1"
                                            >
                                                <icon name="remove" class="icon" title="Delete"></icon>
                                                <i class="icon-label">Delete</i>
                                            </i>
                                        </span>
                                    </footer>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <confirm-dialog
            :is-visible="isDeleteMessageDialogVisible"
            :message="dialogMessage"
            :dialogAction="dialogAction"
            v-on:close="onCofirmDeleteMessageDialog"
        ></confirm-dialog>
        <message-dialog
            :is-visible="isMessageDialogVisible"
            :message="dialogMessage"
            :title="dialogTitle"
            :dialogAction="dialogAction"
            v-on:close="onCofirmMessageDialog"
        ></message-dialog>
    </div>
</template>

<script>
import { Datetime } from "vue-datetime"
import { mapGetters, mapActions } from "vuex"
import store from "../store"
import ConfirmDialog from "./ConfirmDialog.vue"
import MessageDialog from "./MessageDialog.vue"
import { NotificationsMixin } from "./mixin"

export default {
    name: "IncidentEdit",
    props: {
        type: { default: null }
    },
    mixins: [NotificationsMixin],
    components: {
        datetime: Datetime,
        confirmDialog: ConfirmDialog,
        messageDialog: MessageDialog
    },
    data() {
        return {
            isPreviewVisible: false,
            timeout: null,
            dateTimeFormat: {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "2-digit",
                timeZoneName: "short"
            },
            isAddNewMessageVisible: false,
            isEditMessageVisible: false,
            isDeleteMessageDialogVisible: false,
            isMessageDialogVisible: false,
            deleteMessageId: null,
            editMessageId: null,
            dialogMessage: "",
            dialogTitle: "",
            dialogAction: "",
            availableIncidentTypes: [
                { value: "1", text: "Scheduled" },
                { value: "0", text: "Unscheduled" }
            ],
            availableStatuses: [
                { value: "1", text: "Down" },
                { value: "0", text: "Up" }
            ]
        }
    },
    computed: {
        ...mapGetters({
            components: "getComponents",
            incident: "getIncident"
        }),
        availableComponents() {
            return this.components.map(component => {
                return {
                    ...component,
                    value: component.id,
                    text: component.name
                }
            })
        },
        selectedComponent: {
            get() {
                return this.incident.componentId
            },
            set(componentId) {
                this.incident.componentId = componentId
            }
        },
        selectedIncidentType: {
            get() {
                return this.incident.isScheduled ? "1" : "0"
            },
            set(isScheduled) {
                this.incident.isScheduled = isScheduled
            }
        },
        selectedStatus: {
            get() {
                return this.incident.isComponentDown ? "1" : "0"
            },
            set(isComponentDown) {
                this.incident.isComponentDown = isComponentDown
            }
        }
    },
    methods: {
        ...mapActions({
            updateIncident: "updateIncident",
            deleteMessage: "deleteMessage",
            updateMessage: "updateMessage",
            addNewMessage: "addNewMessage",
            loadIncident: "loadIncident"
        }),
        update() {
            this.updateIncident(this.incident).then(
                response => {
                    this.showSuccessMsg({
                        title: "Success.",
                        message: response
                    })
                    this.loadIncident(this.incident.id)
                },
                error => {
                    this.showErrorMsg({
                        title: "Error deleting incident!",
                        message: error
                    })
                }
            )
        },
        confirmDeleteMessage(messageId) {
            this.dialogMessage =
                "Are you sure you want to delete this incident message?"
            this.dialogAction = "Delete"
            this.deleteMessageId = messageId
            this.isDeleteMessageDialogVisible = !this
                .isDeleteMessageDialogVisible
        },
        onCofirmDeleteMessageDialog(isConfirmed) {
            this.isDeleteMessageDialogVisible = !this
                .isDeleteMessageDialogVisible
            if (isConfirmed) {
                this.deleteMessage(this.deleteMessageId).then(
                    response => {
                        this.showSuccessMsg({
                            title: "Success.",
                            message: response
                        })
                        this.loadIncident(this.incident.id)
                    },
                    error => {
                        this.showErrorMsg({
                            title: "Error deleting incident!",
                            message: error
                        })
                    }
                )
            }

            this.deleteMessageId = null
        },
        newIncidentMessage() {
            this.dialogMessage = ""
            this.dialogAction = "Submit"
            this.dialogTitle = "Add new message"
            this.isMessageDialogVisible = !this.isMessageDialogVisible
        },
        editIncidentMessage(message) {
            this.dialogMessage = message.body
            this.dialogAction = "Submit"
            this.dialogTitle = "Add new message"
            this.isMessageDialogVisible = !this.isMessageDialogVisible
            this.editMessageId = message.id
        },
        onCofirmMessageDialog(response) {
            this.isMessageDialogVisible = !this.isMessageDialogVisible
            if (response.isConfirmed) {
                if (this.editMessageId) {
                    let data = {
                        id: this.editMessageId,
                        message: response.message,
                        sendNotification: response.sendNotification
                    }
                    this.updateMessage(data).then(
                        response => {
                            this.showSuccessMsg({
                                title: "Success.",
                                message: response
                            })
                            this.loadIncident(this.incident.id)
                        },
                        error => {
                            this.showErrorMsg({
                                title: "Error updating message!",
                                message: error
                            })
                        }
                    )
                } else {
                    let data = {
                        incidentId: this.incident.id,
                        message: response.message,
                        sendNotification: response.sendNotification
                    }

                    this.addNewMessage(data).then(
                        response => {
                            this.showSuccessMsg({
                                title: "Success.",
                                message: response
                            })
                            this.loadIncident(this.incident.id)
                        },
                        error => {
                            this.showErrorMsg({
                                title: "Error adding message!",
                                message: error
                            })
                        }
                    )
                }
            }
            this.editMessageId = null
        }
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("loadIncident", to.params.id).then(res => next())
    }
}
</script>

<style scoped>
.input-group {
    width: 100%;
}

.preview {
    width: 100%;
    height: 450px;
}

.row--preview {
    padding-top: 30px;
}

.btn--checkbox {
    width: 120px;
}

.btn--message {
    margin-bottom: 10px;
}

.message-action {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/IncidentEdit.vue